import { render, staticRenderFns } from "./ListItemRoot.vue?vue&type=template&id=263b6b5e"
import script from "./ListItemRoot.vue?vue&type=script&lang=ts"
export * from "./ListItemRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports